import { IconButton }  from '@mui/material';
import { 
  DocumentPreviewFileDetails, 
  DocumentPreviewFileName, 
  DocumentPreviewIcon, 
  DocumentPreviewIconRemove, 
  DocumentPreviewThumbnail, 
  DocumentPreviewWrapper 
}                      from '@styles/InputStyles';
import { formatBytes } from '../../commonFunctions';

interface IDocumentPreviewProps {
  file?: File;
  onRemove?(): void;
}

export const DocumentPreview = ({ file, onRemove }: IDocumentPreviewProps) => (
  <DocumentPreviewWrapper>
    <DocumentPreviewIcon />

    <DocumentPreviewThumbnail>
      <DocumentPreviewFileName>{file?.name}</DocumentPreviewFileName>
      <DocumentPreviewFileDetails>
        {file?.type?.split('/')?.reverse()[0]} • {formatBytes(file?.size)}
      </DocumentPreviewFileDetails>
    </DocumentPreviewThumbnail>

    {onRemove && (
      <IconButton color="inherit" onClick={() => onRemove && onRemove()}>
        <DocumentPreviewIconRemove />
      </IconButton>
    )}
  </DocumentPreviewWrapper>
);
